import React from "react";
import PropTypes from "prop-types";
import "./style.less";
import axios from 'axios/dist/axios.min.js'
import utils from "../../utils/utils";
import shihuo, { Exposure } from 'shihuo-lib/dist/shihuo-lib';
import { LazyLoadImage } from 'react-lazy-load-image-component';
let clientWidth = 375;
if (typeof window !== 'undefined') {
  clientWidth = window.document.body.clientWidth;
}
const screenRatio = (clientWidth) / 375;
const bgList = [
  {
    bgColor: '#ff7d8a',
    topUrl: 'https://static.shihuocdn.cn/admin/files/20220427/ad2e8c87c6da20326a3d70e883999f28.png',
    // bgUrl: 'https://static.shihuocdn.cn/admin/files/20220427/9878709ff2985001cf147deed9e14e1d.png',
    btnUrl: 'https://static.shihuocdn.cn/admin/files/20220427/dc7ad3cad73314d08a18b4dd8f27ba74.png',
    bigBtnUrl: 'https://static.shihuocdn.cn/admin/files/20220513/16dce660c61f04878789a08cb516bd14.png'
  },
  {
    bgColor: '#ff7dcb',
    topUrl: 'https://static.shihuocdn.cn/admin/files/20220505/a5de89556459fef847eb2517e279a002.png',
    // bgUrl: 'https://static.shihuocdn.cn/admin/files/20220126/7bcef9be2b7c5474bb414f20240b7b34.png',
    btnUrl: 'https://static.shihuocdn.cn/admin/files/20220505/f42f08d85fd97239ccd01465f8ebb7bd.png',
    bigBtnUrl: 'https://static.shihuocdn.cn/admin/files/20220513/3440d6174d6492664cc503928aca4e2a.png'
  },
  {
    bgColor: '#aa7dff',
    topUrl: 'https://static.shihuocdn.cn/admin/files/20220505/9142055ef4c8e71a5e299260c947cb6e.png',
    // bgUrl: 'https://static.shihuocdn.cn/admin/files/20220126/b588866f88a38103095f80f82724ebe7.png',
    btnUrl: 'https://static.shihuocdn.cn/admin/files/20220505/a3e53c1172664c6e59da30f8b5b296d2.png',
    bigBtnUrl: 'https://static.shihuocdn.cn/admin/files/20220513/35c53556e05556b5c49ddaf428413fd2.png'
  },
  {
    bgColor: '#9a9fff',
    topUrl: 'https://static.shihuocdn.cn/admin/files/20220506/1e9b933b4474fbc99487fc99c46fbc0d.png',
    // bgUrl: 'https://static.shihuocdn.cn/admin/files/20220126/9b77591cfd7df4e0467a13a2d74928a7.png',
    btnUrl: 'https://static.shihuocdn.cn/admin/files/20220505/5d7cc4fd4ea7dd39066bee76a74eefd5.png',
    bigBtnUrl: 'https://static.shihuocdn.cn/admin/files/20220513/9e6b28a68b84386a02f22f89405069aa.png'
  }
];
const searchKeyHref = 'shihuo://www.shihuo.cn?route=goodsList&keywords='
class PipelineSenceFloor extends React.Component {
  constructor(props) {
    super(props);
    this.exp = new Exposure();
    this.state = {
      goodsList: [],
      curTabIndex: 0,
      navFixed: false
    }
    this.tabActive = utils.getParams('tabActive')
    this.clickMoreNum = 0;
    this.goods_type = 3
    // this.goods_type = typeof window !== "undefined" && (window.squareStageType == '预售' ? 1 : (window.squareStageType == '预热' ? 2 : (window.squareStageType == '全部商品' ? 0 : 3)))
    this.pageId = typeof window !== "undefined" && window.location.host === "zt-public.shihuo.cn"
      ? window.location.href.indexOf('zt-public.shihuo.cn/stage') > -1
        ? window.location.pathname.split("/")[3]
        : window.location.pathname.split("/")[2]
      : 0;
  }

  async componentDidMount() {
    this.gender = await this.getMenuBarConfigSex();
    this.getMainPushGoodsList();

    typeof window !== "undefined" && window.addEventListener("scroll", this.onScroll);
  }

  getMenuBarConfigSex(){
    const {allComponents=[]} = this.props;
    let menuData = null;
    allComponents && allComponents.map(item=>{
      if(item.name == 'pipeline-menuBar'){
        menuData = item.data && item.data.containerConfig && item.data.containerConfig.grains
      }
    })
    let title = '';
    if(menuData && menuData.length > this.tabActive){
      title = menuData[this.tabActive] && menuData[this.tabActive].menuName
    }
    if(title) return title.indexOf('男') > -1 ? 'male' : title.indexOf('女') > -1 ? 'female' : 'common'
    return 'common'
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.tabActive != nextProps.tabActive) {
      this.setState({
        curTabIndex: 0,
        navFixed: false
      })
    }
    return true
  }

  // 场景Tab点击
  handleTabItemClick(index, item = {}) {
    // const { goodsList = [] } = this.state;
    // shihuo.uploadTrack({
    //   page_id: this.pageId,
    //   pti: {
    //     id: `lego-valentineDay:sence-floor-tab:${index}`,
    //     pageId: this.pageId,
    //     page_id: this.pageId,
    //     name: goodsList && goodsList[index] && goodsList[index].tabTitle
    //   }
    // });
    const { tabTitle = '' } = item;
    const newProps = JSON.parse(JSON.stringify(this.props));
    Object.assign(newProps, {
      tabChName: tabTitle,
      floor_name: tabTitle
    });
    utils.uploadTrack(newProps, {
      sort: index
    }, { bizExtra: { model_block: 'tab',floor_name: tabTitle } });
    const scrollerY = window.document.querySelectorAll('.sence-floor')[index].offsetTop - this.props.navigationBarHeight - window.document.querySelector('.sence-nav-container').clientHeight + (utils.isAndroid() ? 4 : 0);
    window.scrollTo(0, scrollerY);
    this.setState({
      curTabIndex: index,
    });
  }

  // 获取楼层主推商品列表
  getMainPushGoodsList = () => {
    let requestIndex = 0;  // 楼层数据请求的数量
    const { typeConfig } = this.props.config;
    // console.log('this.props.config===', this.props.config);
    const { typeList = [] } = typeConfig;
    typeList && typeList.forEach((senceTabItem, senceTabIndex) => {
      const { mainPush } = senceTabItem;
      const moduleElement = {
        index: senceTabIndex,
        tabCurIndex: 0,
        configType: mainPush.configType,
        ...senceTabItem,
        mainPushList: [],
      }

      if (mainPush.configType === "商品id(维度)" || mainPush.configType === "配色id(维度)") {
        const pref = mainPush.configType === "商品id(维度)" ? 'g' : 'p'
        const itemList = ((pref == 'g' && mainPush.layout_goodsId.id) || mainPush.layout_styleId.id).split(",");
        const idList = itemList.map((item) => {
          return isNaN(Number(item)) ? 0 : pref + item;
        });

        axios({
          baseURL: 'https://sh-gateway.shihuo.cn',
          url: '/v4/services/sh-venueapi/common/goodsListByIds?access_token=znSnA7pxO35wtPBaur',
          method: "post",
          withCredentials: true,
          data: {
            goods_id: idList,
            goods_type: this.goods_type
          },
        }).then((res) => {
          if (res.data.status === 0) {
            const list = res.data.data.goods_list || [];
            // 插入定制化内容
            list.forEach((product, indexNum) => {
              let customItem = null;
              if (mainPush.configType === "商品id") {
                customItem = itemList.find && itemList.find((item) => item.id == product.goodsId);
              } else {
                customItem = itemList.find && itemList.find((item) => item.id == product.styleId);
              }
              if (customItem) {
                product.custom_image = customItem.image;
                product.custom_title = customItem.title;
                product.custom_subTitle = customItem.subTitle;
              }
            });
            Object.assign(moduleElement, {
              mainPushList: list
            })
            if (moduleElement.searchKeyList && moduleElement.searchKeyList.length > 0) {
              moduleElement.searchKeyList = this.handleSearchKeySort(moduleElement.searchKeyList);
            }
            let goodsList = this.state.goodsList;
            goodsList.push(moduleElement);
            if (goodsList && goodsList.length > 0) {
              goodsList && goodsList.map((item, index) => {
                if (item.mainPushList && item.mainPushList.length > 0) {
                  item.showMore = item.mainPushList.length > 6;
                  item.endRange = item.mainPushList.length >= 6 ? 6 : item.mainPushList.length;
                  item.clickMoreNum = 0;
                }
                const { categoryRecommendTab = [] } = item;
                categoryRecommendTab && categoryRecommendTab.map(imgItem => {
                  const { imgList = [] } = imgItem;
                  let img = ''
                  // console.log('imgList',imgItem);
                  if (imgList && imgList.length > 0) {
                    const currentBg = imgList[Math.round(Math.random() * (imgList.length - 1))] || {}
                    img = currentBg.image || imgList[0].image
                  }
                  imgItem.img = img;
                })
              })
              goodsList = goodsList.sort(this.compareList('index'))
            }
            this.setState({
              goodsList
            }, () => {
              requestIndex++;
            })
          }
        });
      } else if (mainPush.configType === "二级类目id(维度)") {
        const itemList = (mainPush.layout_categoryId.id || mainPush.layout_categoryId.id).split(",");
        const idList = itemList.map((item) => {
          return isNaN(Number(item)) ? 0 : item;
        });
        axios({
          baseURL: 'https://sh-gateway.shihuo.cn',
          url: '/v4/services/sh-venueapi/common/goodsListByCate?access_token=znSnA7pxO35wtPBaur',
          method: 'post',
          withCredentials: true,
          data: {
            cate: idList,
            page_size: 66,
            page_on: 1,
            goods_type: this.goods_type,
            from: window.location.href,
            scene: 'ACTIVITY_11_GOODSLIST_REC',
            goods_from: 0,
            gender: this.gender
          },
        }).then((res) => {
          if (res.data.status === 0) {
            const list = res.data.data.goods_list || [];
            // 插入定制化内容
            list.forEach((product, indexNum) => {
              let customItem = null;
              if (mainPush.configType === "商品id") {
                customItem = itemList.find && itemList.find((item) => item.id == product.goodsId);
              } else {
                customItem = itemList.find && itemList.find((item) => item.id == product.styleId);
              }
              if (customItem) {
                product.custom_image = customItem.image;
                product.custom_title = customItem.title;
                product.custom_subTitle = customItem.subTitle;
              }
            });
            Object.assign(moduleElement, {
              mainPushList: list
            })
            if (moduleElement.searchKeyList && moduleElement.searchKeyList.length > 0) {
              moduleElement.searchKeyList = this.handleSearchKeySort(moduleElement.searchKeyList);
            }
            let goodsList = this.state.goodsList;
            goodsList.push(moduleElement);
            if (goodsList && goodsList.length > 0) {
              goodsList && goodsList.map((item, index) => {
                if (item.mainPushList && item.mainPushList.length > 0) {
                  item.showMore = item.mainPushList.length > 6;
                  item.endRange = item.mainPushList.length >= 6 ? 6 : item.mainPushList.length;
                  item.clickMoreNum = 0;
                }
                const { categoryRecommendTab = [] } = item;
                categoryRecommendTab && categoryRecommendTab.map(imgItem => {
                  const { imgList = [] } = imgItem;
                  let img = ''
                  // console.log('imgList',imgItem);
                  if (imgList && imgList.length > 0) {
                    const currentBg = imgList[Math.round(Math.random() * (imgList.length - 1))] || {}
                    img = currentBg.image || imgList[0].image
                  }
                  imgItem.img = img;
                })

              })
              goodsList = goodsList.sort(this.compareList('index'))
            }
            this.setState({
              goodsList,
            }, () => {
              requestIndex++;
            })
          }
        });
      }

    });
  }

  compareList(property) {
    return function (a, b) {
      var value1 = a[property];
      var value2 = b[property];
      return value1 - value2;
    }
  }
  // 楼层主推商品随机展示
  getRandomMainPush = (arr, n) => {
    const result = [];
    for (let i = 0; i < n; i++) {
      var random = Math.floor(Math.random() * arr.length);
      if (result.includes && result.includes(arr[random])) {
        continue;
      }
      result.push(arr[random]);
      arr.splice(random, 1);
    }
    return result;
  }


  onScroll = () => {
    if (typeof window == "undefined") {
      return;
    }
    const tabBar = typeof window !== "undefined" && window.document.querySelector('.sence-nav-container');
    if (!tabBar) {
      return;
    }

    const tabBarHeight = tabBar.clientHeight
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
    const navOffsetTop = tabBar.offsetTop - this.props.navigationBarHeight + (utils.isAndroid() ? 0 : 0);
    const navFixed = window.document.querySelector('.pipeline-sence-floor') && scrollHeight - navOffsetTop >= 0 && scrollHeight - navOffsetTop <= window.document.querySelector('.pipeline-sence-floor').clientHeight - tabBarHeight

    if (navFixed != this.state.navFixed) {
      this.setState({
        navFixed
      });
    }

    const list = window.document.querySelectorAll('.sence-floor') || [];
    const stopIndex = list.length - 1
    for (let i = 0; i < list.length; i += 1) {
      const item = list[i]
      if (item && scrollHeight >= item.offsetTop - tabBarHeight - this.props.navigationBarHeight + (utils.isAndroid() ? 0 : 0)) {
        if (i == list.length - 1 || scrollHeight < list[i + 1].offsetTop - tabBarHeight - this.props.navigationBarHeight + (utils.isAndroid() ? 0 : 0)) {
          const curTabIndex = i > stopIndex ? stopIndex : i
          if (curTabIndex != this.state.curTabIndex) {
            this.setState({
              curTabIndex
            })
          }
          break
        }
      }
    }
  }

  // 搜索词随机排序
  handleSearchKeySort = (arr) => {
    return arr.sort(() => Math.random() - 0.5);
  }

  // 获取Cookie
  getCookie = (name) => {
    var arr,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if ((arr = document.cookie.match(reg))) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  }

  // 加载更多
  handleMore = (target, dataSource, floorIndex) => {
    const { curTabIndex } = this.state;
    const { tabTitle } = dataSource;
    // shihuo.uploadTrack({
    //   pti: {
    //     id: `lego-valentineDay:sence-floor-tab_${curTabIndex + 1}-more:`,
    //     pageId: this.pageId,
    //   }
    // })
    const newProps = JSON.parse(JSON.stringify(this.props));
    Object.assign(newProps, {
      tabChName: '查看更多',
      floor_name: tabTitle
    });
    utils.uploadTrack(newProps, {
      sort: curTabIndex
    }, { bizExtra: { model_block: 'more',floor_name: tabTitle } });
    // console.log('target', target);
    const { mainPushList = [], endRange, clickMoreNum = 0 } = target;
    if (mainPushList && mainPushList.length > endRange && clickMoreNum < 2) {

      ++target.clickMoreNum;
      if (mainPushList.length >= target.clickMoreNum * 30 + 6) {
        target.endRange += 30;
      } else {
        target.endRange += mainPushList.length;
      }
      target.showMore = mainPushList.length > target.endRange && target.clickMoreNum < 2;
      console.log('进入修改', target);
      this.setState({});
    } else {
      target.showMore = false;
      this.setState({});
    }
  }

  renderMoreView(target, dataSource, floorIndex) {
    if (!target || !target.configType) {
      return null;
    }

    if (target.showMore) {
      return (
        <div className="show-more-btn" onClick={() => this.handleMore(target, dataSource, floorIndex)}>
          <p>查看更多</p>
          <img src="https://static.shihuocdn.cn/admin/files/20230117/3e1a3b5b8cbe350cb444cffbee3608a7.png" alt="" />
        </div>
      )
    } else {
      return null;
    }
  }
  transformPx = (num) => {
    // 对单位进行转换
    num = Number(num);
    if (isNaN(num)) {
      num = 0;
    }
    const realNum = Math.round(num * screenRatio);
    return realNum;
  }
  render() {
    const customAttributes = {
      "data-component-id": this.props["data-component-id"],
      "data-component-name": this.props["data-component-name"],
    };

    const { baseConfig, typeConfig } = this.props.config
    const { navFixed, goodsList, curTabIndex } = this.state;

    if (goodsList.length < 1) {
      return null;
    }
    const { title,titleFontColor, titleBgImage } = typeConfig;
    // const marginRight = this.transformPx(clientWidth - this.transformPx(100 * 3 + 26 * 2)) / 2
    // const left = this.transformPx(marginRight);
    // console.log('=goodslist==', goodsList);
    let windowColor = ''
    if (typeof window != 'undefined' && window.backgroundColor) {
      windowColor = window.backgroundColor
    } else if (document.querySelector('body').style.backgroundColor) {
      windowColor = document.querySelector('body').style.backgroundColor
    }
    return (
      <div
        className="pipeline-sence-floor"
        {...this.props['customAttributes']}
        style={{
          marginTop: `${baseConfig.moduleMarginTop}px`,
          marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          marginRight: `${baseConfig.moduleMarginHorizon}px`,
        }}
      >
        <div className="container">
          <div className="sence-nav-container-top">
            <div className="sence-tab-title" style={{
              backgroundImage: `url(${utils.formatImgUrl(titleBgImage, this.props.webpSupport)})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              color: titleFontColor || '#FFFFFF'
            }}>
              <span style={{ fontSize: 20, fontWeight: 'bold' }}>{title}</span>
            </div>
            <div className="sence-nav-container">
              <ul
                className="sence-tab-list"
                style={{
                  position: navFixed ? 'fixed' : 'relative',
                  // position: 'sticky',
                  top: navFixed ? this.props.navigationBarHeight : 0,
                  backgroundColor: navFixed ? (this.props.tabContainerBgColor || windowColor) : 'transparent',
                  zIndex: 10,
                }}
              >
                {
                  goodsList.map((tabItem, tabIndex) => {
                    return (
                      <li
                        className={'tab-item'} key={tabIndex}
                        style={{
                          backgroundImage: `url(${utils.formatImgUrl(curTabIndex == tabIndex ? tabItem.tabSelectedImage : tabItem.tabImage, this.props.webpSupport)})`,
                          // backgroundSize: "contain"
                          backgroundSize: "100% 100%",
                        }}
                        onClick={this.handleTabItemClick.bind(this, tabIndex, tabItem)}
                      >
                      </li>
                    )
                  })
                }
              </ul>
            </div>
          </div>

          {
            goodsList.map((floorItem, floorIndex) => {
              const { titleIcon, tabTitle, tabTitleFontColor, tabDesc, tabDescFontColor, searchKeyList = [],searchKeyBgColor,searchKeyFontColor, categoryRecommendTab = [], mainPushList = [], endRange } = floorItem;
              let { bgColor, topUrl, btnUrl } = floorItem;
              bgColor = bgColor || bgList[0].bgColor;
              topUrl = topUrl || bgList[0].topUrl;
              btnUrl = btnUrl || bgList[0].btnUrl
              return (
                <div
                  className="sence-floor"
                  key={floorIndex}
                  style={{
                    backgroundColor: bgColor
                  }}
                >
                  <div className="main-push-pro">

                    <div className="main-top"
                      style={{
                        zIndex: 1, position: 'absolute', top: 0, left: 0,
                      }}
                    >
                      <LazyLoadImage
                        width="100%"
                        threshold={500}
                        height="100%"
                        src={utils.formatImgUrl(topUrl, this.props.webpSupport)}
                        effect="opacity"
                      />
                    </div>
                    {titleIcon && <div className="main-top"
                      style={{
                        zIndex: 2, position: 'absolute', top: '5px', left: '35%', width: 'auto'
                      }}
                    >
                      <LazyLoadImage
                        width="90px"
                        threshold={500}
                        height="90px"
                        src={utils.formatImgUrl(titleIcon, this.props.webpSupport)}
                        effect="opacity"
                      />
                    </div>}
                    <div className="main-top"
                      style={{
                        zIndex: 3,
                        paddingTop: '12px'
                      }}
                    >

                      <div className="main-top-left">
                        <h3 className="main-top-title" style={{color: tabTitleFontColor || '#000000'}}>{tabTitle}</h3>
                        <div className="sub-top-title" style={{color: tabDescFontColor || '#000000'}}>{tabDesc}</div>
                      </div>
                      <div className="main-top-right">
                        {
                          searchKeyList && searchKeyList.map((mainPushProduct, mainPushIndex) => {
                            if (!mainPushProduct.title) {
                              return null;
                            }
                            // const ptiId = `lego-valentineDay:sence-floor-tab_${floorIndex + 1}-keywords:${mainPushIndex + 1}`
                            return <div key={mainPushIndex} className="main-top-right-item" style={{ backgroundColor: searchKeyBgColor || '#00000040', color: searchKeyFontColor || '#FFFFFF'}} onClick={() => {
                              // utils.handleItemClick(this.props.routeParams,
                              //   `${searchKeyHref}${encodeURIComponent(mainPushProduct.title)}`,
                              //   {},
                              //   { ptiId, page_id: this.pageId, pageId: this.pageId, typeName: tabTitle },
                              //   { id: ptiId })
                              const detailHref = `${searchKeyHref}${encodeURIComponent(mainPushProduct.title)}`
                              const options = {
                                sort: mainPushIndex,
                                tabChName: mainPushProduct.title,
                                floor_name: tabTitle
                              }
                              utils.jumpToUrl(this.props.routeParams, detailHref, detailHref, options, -1, { ...this.props, ...options }, false, { typeName: tabTitle, bizExtra: { model_block: 'keywords',floor_name: tabTitle } });
                            }}>
                              <span style={{ textAlign: 'center', lineHeight: '20px',marginBottom: utils.isAndroid() ? '-2px': '0px'  }}>{mainPushProduct.title}</span>
                            </div>
                          })
                        }
                      </div>
                    </div>
                  </div>
                  <div className="category-pro-wrap">
                    <ul className="category-pro-list">
                      {categoryRecommendTab && categoryRecommendTab.slice(0, 3).map((categoryProItem, categoryProIndex) => {
                        let { btnName, imgList = [], img = '' } = categoryProItem;

                        return (
                          <li
                            key={categoryProIndex}
                            onClick={() => {
                              const detailHref = categoryProItem.detailHref || categoryProItem.link;
                              const goods_id = categoryProItem.goodsId || categoryProItem.id;
                              const style_id = categoryProItem.styleId || categoryProItem.id;
                              const options = {
                                sort: categoryProIndex,
                                tabChName: categoryProItem.title || categoryProItem.goodsName,
                                floor_name: tabTitle
                              }
                              utils.jumpToUrl(this.props.routeParams, detailHref, detailHref, options, -1, { ...this.props, ...options }, false, {
                                typeName: categoryProItem.title || categoryProItem.goodsName,
                                floor_name: tabTitle,
                                name: categoryProItem.title || categoryProItem.goodsName, goods_id, style_id, bizExtra: { model_block: 'recommendCategory',floor_name: tabTitle }
                              });
                            }}
                          >
                            <div className="pro-item-parent">
                              <img
                                className="pro-item-img"
                                src={utils.formatImgUrl(img, this.props.webpSupport)}
                              />
                              <div className="pro-item-one">
                                <p className="title">{categoryProItem.title || categoryProItem.goodsName}</p>
                              </div>
                            </div>
                            <div
                              className="btn"
                              style={{ backgroundImage: `url(${utils.formatImgUrl(btnUrl, this.props.webpSupport)})`, backgroundSize: "100% 100%" }}
                            >{btnName}
                              <img className="btn-arrow-img" src={utils.formatImgUrl('https://static.shihuocdn.cn/admin/files/20220512/1d3b780d8f34171ec441f7bdbe4237c1.png', this.props.webpSupport)} />
                            </div>

                          </li>
                        )
                      })}
                    </ul>
                    <ul className="category-pro-list">
                      {mainPushList && mainPushList.slice(0, endRange).map((categoryProItem, categoryProIndex) => {
                        const detailHref = categoryProItem.detailHref || categoryProItem.link;
                        const ptiId = `lego-valentineDay:sence-floor-tab_${floorIndex}-goods:${categoryProIndex}`
                        const goods_id = categoryProItem.goodsId || categoryProItem.id;
                        const style_id = categoryProItem.styleId || categoryProItem.id;
                        return (
                          <li
                            key={categoryProIndex}
                            onClick={() => {
                              const options = {
                                sort: categoryProIndex,
                                tabChName: categoryProItem.goodsName || categoryProItem.title,
                                floor_name: tabTitle
                              }
                              utils.jumpToUrl(this.props.routeParams, detailHref, detailHref, options, -1, { ...this.props, ...options }, false, {
                                typeName: categoryProItem.goodsName || categoryProItem.title,floor_name: tabTitle, goods_id, style_id, bizExtra: { model_block: 'goods',floor_name: tabTitle }
                              });
                            }}
                            data-dot={JSON.stringify({
                              id: ptiId,
                              name: '',
                              href: '',
                              biz: JSON.stringify({
                                ptiId,
                                page_id: this.pageId,
                                pageId: this.pageId,
                                typeName: tabTitle,
                                goods_id,
                                style_id
                              }),
                              exposekey: `floor_categoryProIndex_${categoryProIndex}`,
                              pti_refer: {
                                pageId: '',
                                root: {
                                  id: '',
                                  pageId: '',
                                  name: '',
                                  biz: '',
                                },
                                parent: {
                                  id: '',
                                  pageId: '',
                                  name: '',
                                  biz: '',
                                },
                              },
                            })}
                            ref={ele => {
                              if (ele) {
                                this.exp.add({ el: ele });
                              }
                            }}
                          >
                            <div className="pro-item-parent">
                              <img
                                className="pro-item-img"
                                src={utils.formatImgUrl(categoryProItem.pic || categoryProItem.image, this.props.webpSupport)}
                              />
                              <div className="pro-item">
                                <p className="title">{categoryProItem.goodsName || categoryProItem.title}</p>
                                <p className="price">¥{categoryProItem.price}</p>
                              </div>
                            </div>
                          </li>
                        )
                      })}
                    </ul>
                    {this.renderMoreView(floorItem, floorItem, floorIndex)}
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    );
  }
}

PipelineSenceFloor.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineSenceFloor };
export default PipelineSenceFloor;


// WEBPACK FOOTER //
// ./components/pipeline-sence-floor/index.js